const SPLITTER = ' | '

export const getTitle = () => {
  const [companyName, ...other] = document.title.split(SPLITTER)

  return [companyName, ...other]
}

export const setTitle = ([...other]) => {
  document.title = ['Capino', ...other].filter(Boolean).join(SPLITTER)
}
